var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.bemBlock,
      attrs: { itemtype: "http://schema.org/SomeProducts" }
    },
    [
      _vm.infinitePrevious
        ? _c(
            "InfiniteLoading",
            {
              attrs: {
                "force-use-infinite-wrapper": _vm.infiniteWrapper,
                identifier: _vm.infiniteTopKey,
                direction: "top"
              },
              on: { infinite: _vm.infinitePrevHandler }
            },
            [
              _c("div", { attrs: { slot: "spinner" }, slot: "spinner" }),
              _vm._v(" "),
              _c("div", { attrs: { slot: "no-more" }, slot: "no-more" }),
              _vm._v(" "),
              _c("div", { attrs: { slot: "no-results" }, slot: "no-results" })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.backgroundImage
        ? _c("div", {
            class: [_vm.bemElement("background-container")],
            style: _vm.cssCustomProps
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ul",
        {
          class: _vm.bemElement("list"),
          attrs: { itemtype: "http://schema.org/SomeProducts" }
        },
        [
          _vm._l(_vm.products, function(tileData, index) {
            var _obj
            return [
              tileData.display.linebreak && _vm.numAppliedFilters === 0
                ? _c("li", {
                    key: index + "-linebreak",
                    class: [_vm.bemElement("linebreak")]
                  })
                : _vm._e(),
              _vm._v(" "),
              tileData.display.categorySeparator
                ? _c("li", {
                    directives: [
                      {
                        name: "observe-visibility",
                        rawName: "v-observe-visibility",
                        value: {
                          callback: function(isVisible, entry) {
                            return _vm.observeCategorySeparator(
                              entry,
                              tileData.categories
                            )
                          },
                          intersection: {
                            rootMargin:
                              "-" + _vm.headerHeight + "px 0px 0px 0px",
                            threshold: 1
                          },
                          once: false
                        },
                        expression:
                          "{\n          callback: (isVisible, entry) =>\n            observeCategorySeparator(entry, tileData.categories),\n          intersection: {\n            rootMargin: `-${headerHeight}px 0px 0px 0px`,\n            threshold: 1,\n          },\n          once: false,\n        }"
                      }
                    ],
                    key: index + "-linebreak",
                    class: [_vm.bemElement("linebreak"), "intersection"],
                    attrs: { "data-page-url": tileData.categories.next.url }
                  })
                : _vm._e(),
              _vm._v(" "),
              index === _vm.products.length - _vm.numItemsBasedBreakpoint
                ? _c(
                    "li",
                    {
                      key: "infinite-loading-wrapper-" + index,
                      class: [_vm.bemElement("hidden-trigger")]
                    },
                    [
                      _c(
                        "InfiniteLoading",
                        {
                          attrs: {
                            "force-use-infinite-wrapper": _vm.infiniteWrapper
                          },
                          on: { infinite: _vm.infiniteNextHandler }
                        },
                        [
                          _c("div", {
                            attrs: { slot: "spinner" },
                            slot: "spinner"
                          }),
                          _vm._v(" "),
                          _c("div", {
                            attrs: { slot: "no-more" },
                            slot: "no-more"
                          }),
                          _vm._v(" "),
                          _c("div", {
                            attrs: { slot: "no-results" },
                            slot: "no-results"
                          })
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.shouldShowBanner(tileData)
                ? _c(
                    "li",
                    {
                      key: "grid-banner-wrapper-" + index,
                      class: [
                        _vm.bemElement(
                          "item",
                          ((_obj = {
                            "double-width":
                              _vm.isBannerDoubleWidth(tileData) ||
                              _vm.isTileDoubleWidth(
                                tileData.display.doublewidth
                              ),
                            minimal: _vm.useMinimalTiles
                          }),
                          (_obj[
                            _vm.paramCase(tileData.product.banner.type)
                          ] = true),
                          _obj)
                        ),
                        "grid-banner-wrapper"
                      ],
                      attrs: { "data-key": "grid-banner-wrapper-" + index }
                    },
                    [
                      _c(
                        "TheGridBanner",
                        _vm._b(
                          {
                            attrs: {
                              keyid: "grid-banner-" + index,
                              "force-main-image-to-load":
                                index <=
                                _vm.indexOfLatestTileToPreloadMainImage,
                              "grid-index": index,
                              "grid-type": _vm.type,
                              minimal: _vm.useMinimalTiles,
                              product: tileData.product
                            }
                          },
                          "TheGridBanner",
                          tileData.display,
                          false
                        )
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isSliderBannerDesktop(tileData)
                ? _vm._l(tileData.product.banner.productSlider, function(
                    sliderProduct,
                    sliderIndex
                  ) {
                    return _c(
                      "li",
                      {
                        key:
                          "product-tile-wrapper-" +
                          sliderProduct.id +
                          "-" +
                          index +
                          "-" +
                          sliderIndex,
                        class: [
                          _vm.bemElement("item", {
                            minimal: _vm.useMinimalTiles
                          }),
                          "product-tile-wrapper"
                        ],
                        attrs: {
                          "data-key":
                            "product-tile-wrapper-" +
                            sliderProduct.id +
                            "-" +
                            index +
                            "-" +
                            sliderIndex
                        }
                      },
                      [
                        _vm.isSliderProductEnriched(sliderProduct)
                          ? _c("BaseProductTile", {
                              attrs: {
                                analytics: _vm.buildAnalyticsPropForProduct({
                                  location:
                                    _vm.analyticsConst.location.plpSliderBanner,
                                  position: index + (sliderIndex + 1) / 10
                                }),
                                "are-carousel-controls-shown":
                                  _vm.shouldShowCarouselControls,
                                keyid:
                                  sliderProduct.id +
                                  "-" +
                                  index +
                                  "-" +
                                  sliderIndex,
                                context: _vm.getTileContext(sliderProduct),
                                "force-main-image-to-load":
                                  index <=
                                  _vm.indexOfLatestTileToPreloadMainImage,
                                "grid-index": sliderIndex,
                                "grid-type": _vm.type,
                                minimal: _vm.useMinimalTiles,
                                product: sliderProduct,
                                url: sliderProduct.selectedProductUrl || "",
                                "show-swatches": false
                              },
                              on: {
                                "load-main-image": function($event) {
                                  return _vm.handleLoadMainImage(index)
                                }
                              }
                            })
                          : _c("BaseProductTileImage", {
                              attrs: {
                                "has-carousel": false,
                                url: sliderProduct.url || "",
                                context: _vm.getTileContext(sliderProduct),
                                "force-main-image-to-load":
                                  index <=
                                  _vm.indexOfLatestTileToPreloadMainImage,
                                product: _vm.toSliderSkeletonProduct(
                                  sliderProduct
                                )
                              }
                            })
                      ],
                      1
                    )
                  })
                : tileData.product && !tileData.product.banner
                ? _c(
                    "li",
                    {
                      key:
                        "product-tile-wrapper-" +
                        tileData.product.id +
                        "-" +
                        index,
                      class: [
                        _vm.bemElement("item", {
                          "double-width": _vm.isTileDoubleWidth(
                            tileData.display.doublewidth
                          ),
                          minimal: _vm.useMinimalTiles
                        }),
                        "product-tile-wrapper"
                      ],
                      attrs: {
                        "data-key":
                          "product-tile-wrapper-" +
                          tileData.product.id +
                          "-" +
                          index
                      }
                    },
                    [
                      _c("BaseProductTile", {
                        attrs: {
                          "are-carousel-controls-shown":
                            _vm.shouldShowCarouselControls,
                          keyid: tileData.product.id + "-" + index,
                          analytics: _vm.buildAnalyticsPropForProduct({
                            position: index
                          }),
                          context: _vm.getTileContext(tileData),
                          "force-main-image-to-load":
                            index <= _vm.indexOfLatestTileToPreloadMainImage,
                          "grid-index": index,
                          "grid-type": _vm.type,
                          minimal: _vm.useMinimalTiles,
                          "hide-prices": _vm.shouldShowPrices(tileData),
                          "hide-tags": _vm.shouldShowTags(tileData),
                          product: tileData.product,
                          url: tileData.urls.product,
                          "show-swatches": _vm.shouldShowSwatches(tileData),
                          "virtualize-when-offscreen": true
                        },
                        on: {
                          "load-main-image": function($event) {
                            return _vm.handleLoadMainImage(index)
                          },
                          "open-pdp-modal": function(product) {
                            return _vm.$emit("open-pdp-modal", product)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm._t("afterList"),
      _vm._v(" "),
      _vm.infiniteNext
        ? _c(
            "InfiniteLoading",
            {
              attrs: {
                "force-use-infinite-wrapper": _vm.infiniteWrapper,
                identifier: _vm.infiniteBottomKey
              },
              on: { infinite: _vm.infiniteNextHandler }
            },
            [
              _c(
                "div",
                { attrs: { slot: "spinner" }, slot: "spinner" },
                [
                  _vm.bottomSpinner !== null
                    ? _c("span", { staticClass: "interaction--loader-grid" }, [
                        _vm._v("\n        " + _vm._s(_vm.bottomSpinner))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.bottomSpinner === null
                    ? _c("BaseSpinner", { attrs: { inline: "" } })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { attrs: { slot: "no-more" }, slot: "no-more" }),
              _vm._v(" "),
              _c("div", { attrs: { slot: "no-results" }, slot: "no-results" })
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }